export enum Role {
  Admin = 'admin',
  Tenant = 'tenant',
  Contributor = 'contributor',
  Author = 'author'
}
